import { Injectable, Injector } from '@angular/core';
import {
  DataDomainClient,
  DataDomainSourceDataOutputDto,
  DataDomainSourceDataOutputDtoEntityActionResultDto,
} from '../../core/remote-clients/remote-client';
import { firstValueFrom } from 'rxjs';
import { RemoteResponse, RemoteServiceBase } from './remote-base.service';

export interface DataDomainDependency {
  name: string;
  value: string;
}

@Injectable()
export class RemoteDataDomainService extends RemoteServiceBase {
  protected readonly _dataDomainClient: DataDomainClient;

  constructor(injector: Injector) {
    super(injector);

    this._dataDomainClient = injector.get(DataDomainClient);
  }

  public async getDataSource(
    domainId: string,
    versionId: string,
    searchTerm: string | undefined
  ): Promise<DataDomainSourceDataOutputDto> {
    const dataSourceRequest = this.isGuest
      ? this._dataDomainClient.dataSourceGuest(domainId, versionId, searchTerm)
      : this._dataDomainClient.dataSource(domainId, versionId, searchTerm);

    const result = (await firstValueFrom(
      dataSourceRequest
    )) as DataDomainSourceDataOutputDtoEntityActionResultDto;

    this.validateResponse(result as RemoteResponse);

    return result.entity!;
  }

  public async getDataSourceWithDependencies(
    domainId: string,
    versionId: string,
    dependencies: DataDomainDependency[],
    searchTerm?: string
  ): Promise<DataDomainSourceDataOutputDto> {
    if (!dependencies || dependencies.length === 0) {
      return this.getDataSource(domainId, versionId, searchTerm);
    }

    const names = dependencies.map(d => d.name);
    const values = dependencies.map(d => d.value);

    const dataSourceRequest = this.isGuest
      ? this._dataDomainClient.dataSourceDepsGuest(domainId, versionId, names, values, searchTerm)
      : this._dataDomainClient.dataSourceDeps(domainId, versionId, names, values, searchTerm);

    const result = (await firstValueFrom(
      dataSourceRequest
    )) as DataDomainSourceDataOutputDtoEntityActionResultDto;

    this.validateResponse(result as RemoteResponse);

    return result.entity!;
  }
}
